import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AuthPayloadService {
  // Secret is now server-only for contact/agent forms (signed in BFF).
  // Remaining pricing-api calls use a public challenge for bot-deterrence only.
  private secretKey = 'aca*GJK63e&jaabs@xF5#22jsdlk&gtd%$D9';

  generatePayload(): any {
    const randomText = uuidv4();
    const timestamp = Math.floor(Date.now() / 1000);
    const nonce = uuidv4();

    const message = `${randomText}|${timestamp}|${nonce}`;
    const signature = CryptoJS.HmacSHA256(message, this.secretKey).toString(CryptoJS.enc.Hex);

    const payload = {
      challenge: randomText,
      timestamp,
      nonce,
      signature,
      appname : 'GlicRx',
    };
    return payload;
  }
}